export default __webpack_public_path__ + "static/media/webcam-guide.435c52b7.svg";